import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 13.924 13.924",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.924 13.924\" id=\"icon-close\">\r\n  <g id=\"icon-close_组_904\" data-name=\"组 904\" transform=\"translate(-1867.793 -750.793)\">\r\n    <line id=\"icon-close_直线_68\" data-name=\"直线 68\" x2=\"12.51\" y2=\"12.51\" transform=\"translate(1868.5 751.5)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"1\" />\r\n    <line id=\"icon-close_直线_69\" data-name=\"直线 69\" x1=\"12.51\" y2=\"12.51\" transform=\"translate(1868.5 751.5)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"1\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close.svg
// module id = toIl
// module chunks = 167